import React from 'react';
import { withRouter} from 'react-router-dom';
import CookieConsent from "react-cookie-consent";

import LandingLayout from 'component/page/landing';
import Survey from 'component/content/survey';
import BBPromo from 'component/content/bb_promo';
import Popular from 'component/content/popular';


class Page extends React.Component {
  render (){
    return (
      <LandingLayout id="landing-page">
        <CookieConsent>
          This website uses cookies to enhance the user experience.
        </CookieConsent>

        <div className="bg-light">
          <Survey />
        </div>

        <Popular />

        <BBPromo />

      </LandingLayout>
    )
  }
}

export default withRouter(Page);
